import React from 'react';
import _ from 'lodash';
import MenuItem from './ListMenuItem';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { object, any, array, bool } from 'prop-types';
import useFocusMenu from '../common/Tag/useFocusMenu';
import {
  MENU_CHECK_API,
  MENU_CHECK_LANG,
  MENU_CHECK_PATH,
  MENU_CHECK_USER,
  MENU_CHECK_USER_LOG_OUT,
  MENU_TYPE_LINK,
  MENU_CHECK_ALLOW_HOME_DELIVERY
} from '../../constants/defaults';

const { API } = require(`../../config/${process.env.REACT_APP_ENV}`);

const Menu = ({
  menu,
  listOthers,
  isAccessByUPDownKey,
  userName,
  imageOthers,
  refElement
}) => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const { pathname = '' } = useLocation();

  let rendererMenu = [];
  let condition = '';
  let pathCondition = '';

  _.map(menu, item => {
    condition = '';
    if (_.isEmpty(item.check)) {
      condition = true;
    } else {
      _.map(item.check, checkCondition => {
        switch (checkCondition) {
          case MENU_CHECK_USER:
            condition = _.isEmpty(condition)
              ? !_.isEmpty(userName)
              : !_.isEmpty(userName) && condition;
            break;
          case MENU_CHECK_USER_LOG_OUT:
            condition = _.isEmpty(condition)
              ? _.isEmpty(userName)
              : _.isEmpty(userName) && condition;
            break;
          case MENU_CHECK_PATH:
            pathCondition =
              pathname.match(/^\/prescription\/[A-Za-z0-9-_]*$/) ||
              pathname.match(/^\/es\/medicamento\/[A-Za-z0-9-_]*$/);
            pathCondition = _.isEmpty(pathCondition) ? false : true;
            condition = _.isEmpty(condition)
              ? pathCondition
              : condition && pathCondition;
            break;
          case MENU_CHECK_API:
            condition = _.isEmpty(condition)
              ? API.ALLOW_CONDITIONS
              : API.ALLOW_CONDITIONS && condition;
            break;
          case MENU_CHECK_ALLOW_HOME_DELIVERY:
            condition = _.isEmpty(condition)
              ? API.ALLOW_HOME_DELIVERY
              : API.ALLOW_HOME_DELIVERY && condition;
            break;
          case MENU_CHECK_LANG:
            condition = _.isEmpty(condition)
              ? _.isEqual(lang.toString(), 'en')
              : _.isEqual(lang.toString(), 'en') && condition;
            break;
        }
      });
    }

    condition && rendererMenu.push(item);
  });

  const [focus] = useFocusMenu(rendererMenu.length);
  return (
    <ul
      {...listOthers}
      className="main-header--submenu dashboard"
      {...(!_.isEmpty(refElement) ? { ref: refElement } : '')}
    >
      {_.map(rendererMenu, (item, index) => {
        let others = {
          ...(item.type === MENU_TYPE_LINK ? { href: item.url } : '')
        };
        others = { ...others, ...item.others };
        return (
          <MenuItem
            key={item.name}
            item={item}
            focus={focus === index}
            isAccessByUPDownKey={isAccessByUPDownKey}
            anchorClasses="adaMenu sc-top-item-link"
            imageOthers={imageOthers}
            others={others}
          />
        );
      })}
    </ul>
  );
};

Menu.propTypes = {
  refElement: any,
  menu: array,
  listOthers: any,
  isAccessByUPDownKey: bool,
  userName: any,
  imageOthers: object
};
Menu.defaultProps = {
  refElement: '',
  menu: [],
  listOthers: '',
  isAccessByUPDownKey: false,
  userName: '',
  imageOthers: {}
};
export default Menu;
